import React from 'react';
import { Box, Typography } from '@mui/material';

import { Scrollbar } from '@europrocurement/flexy-components';
import { GrilleTarifaire } from '@europrocurement/l2d-modules/modules/GrilleTarifaire/page/GrilleTarifaire';

/**
 * Page "Grille tarifaire" accessible depuis le sous-menu Administration.
 * Reprend la configuration d'affichage qui était auparavant dans l'onglet
 * "Grille tarifaire" du dashboard des offres.
 */
const AdminGrilleTarifaire: React.FunctionComponent = function () {
    return (
        <Box sx={{ overflow: 'hidden' }}>
            <Typography
                variant="h1"
                sx={{ marginBottom: 2 }}
            >
                Grille tarifaire
            </Typography>

            <Scrollbar
                style={{
                    maxHeight: '75vh',
                }}
            >
                <GrilleTarifaire
                    showOrigineFilter
                    showNumberCatalogue
                    showOffer
                    showElement
                    showTTC={false}
                    showAction
                    surchargeAL
                    surchargeFD
                    surchargeCatalogue
                    surchargePackage
                    surchargeHonoraire={false}
                    waitPrescripteur={false}
                />
            </Scrollbar>
        </Box>
    );
};

export default AdminGrilleTarifaire;
